import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import type { FC } from 'react';
import translations from './.vocab';

interface NewBadgeProps {
  weight?: 'regular' | 'strong';
}
export const NewBadge: FC<NewBadgeProps> = ({
  weight = 'regular',
}: NewBadgeProps) => {
  const { t } = useTranslations(translations);
  return (
    <Badge tone="positive" weight={weight}>
      {t('New')}
    </Badge>
  );
};
